import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
export default {
  name: "basicContainer",
  props: {
    radius: {
      type: [String, Number],
      default: 10
    },
    background: {
      type: String
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    styleName: function styleName() {
      return {
        borderRadius: this.setPx(this.radius),
        background: this.background
      };
    }
  }
};